export default __webpack_public_path__ + "static/media/postgresql.d80e6615.svg";